/**
 * comicPanels — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {PORTRAIT, tagline, chips, type ToilePack} from './data'

export const comicPanelsPack: ToilePack = {
    slug: 'comic-panels',
    category: 'comics',
    name: 'Comic pages',
    tagline: tagline('pages', 'page types', 'inking styles'),
    chips: chips('page types', 'styles'),
    ratio: PORTRAIT,
    readings: [
        {key: 'chase', label: 'Rooftop chase', subject: 'five panels: a vault over a rooftop unit, running feet, a caught ledge'},
        {key: 'dialogue', label: 'Quiet dialogue', subject: 'six even panels: two figures at a kitchen table, a cup being turned'},
        {key: 'splash', label: 'Splash reveal', subject: 'a full-page splash: a figure in a ruined doorway, a silhouette behind'},
    ],
    styles: [
        {key: 'ink', label: 'American ink', style: 'bold brush inking, heavy spot blacks and feathered shadow', palette: 'flat saturated color separations', framing: 'white gutters, empty balloons'},
        {key: 'manga', label: 'Manga', style: 'screentone dot shading, speed and focus lines', palette: 'black and white only', framing: 'white gutters, empty balloons'},
        {key: 'ligne', label: 'Ligne claire', style: 'uniform thin outlines with no hatching', palette: 'flat even color fills, a bright palette', framing: 'white gutters, empty balloons'},
    ],
    directions: ['a noir detective story', 'in pouring rain at night', 'tighter crops, more panels'],
}
